import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { i18nextFormatCallback } from 'utils/old-ui-commons/formats';

import en from '../locales/en/translation.json';
import br from '../locales/pt-BR/translation.json';

export const DEFAULT_LANGUAGE = 'pt-br';

const resources = {
  'pt-BR': {
    translation: br,
  },
  en: {
    translation: en,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    resources,
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    keySeparator: false,
    nsSeparator: false,
    ns: ['translation'],
    defaultNS: 'translation',
    supportedLngs: ['pt-BR'],
    interpolation: {
      escapeValue: false,
      format: i18nextFormatCallback,
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged',
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b'],
    },
  });

export default i18n;
